import React, { useState } from 'react'
import axios from '@fuse/utils/axios';
import {yupResolver} from '@hookform/resolvers/yup';
import {
    makeStyles
} from '@material-ui/core'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import useToast from '@fuse/hooks/useToast';
import ColorPicker from '@fuse/components/ColorPicker'
import { Button, DialogTitle, TextField, TextareaAutosize, Typography, Dialog,DialogContent, DialogActions } from '@mui/material'


const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}))

const AddServicePriorityFromQuickAction = ({
    handleOpenCloseAddModalEvent,
    openAddPriorityModalStateData,
    newDataAddedEvent
}) => {

    const classes = useStyles()
    const dispatch = useDispatch()
    const toast = useToast(dispatch)
    const [color, setColor] = useState({name:'black',code:"#000000"});

    const defaultValues = {
        priority_name: '',
    }

    const schema = yup.object({
        priority_name: yup.string().required('Priority name is required!')
            .matches(/^[A-Za-z\s]+$/, 'Priority name cannot contain numbers, alphanumeric characters, or special characters!')
            .matches(/\S/, 'Priority name cannot be only spaces!')
            .max(30, 'Priority name must be at most 30 characters!'),
    })

    const { 
        control, 
        formState:{errors: priorityFormErrors}, 
        handleSubmit: priorityFormSubmit, 
        trigger,
        reset: priorityFormReset 
    } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });


    const onSubmit = async (data) => {
        await trigger();
        if(Object.keys(priorityFormErrors).length !== 0) { 
            return;
        }

        let payload = {
			name: data.priority_name,
			priority_color: color
		}
        axios.post('/service-request-priority/add', payload).then(response => {
                priorityFormReset(defaultValues)
                setColor({name:'black',code:"#000000"})               
                toast.success(response.data.message)
                newDataAddedEvent(response.data.data.new_data)
            }).catch(err => {
				toast.error(err.response.data.message || 'Something went wrong!')
			})
    }


    return (
        <Dialog
            className="cstm_dialog_modal small text-center"
            open={openAddPriorityModalStateData}
            // onClose={handleOpenCloseAddModalEvent}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                <div className='heading_holder flexbox_holder items-center w-full'>
                    <h2 className="main_heading">Add Priority</h2>
                    <Button className='transparent_icon_btn' onClick={handleOpenCloseAddModalEvent}>
                        <i className="icon ti ti-x" />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="text-left">
                    <div className='mb-10'>
                        <Typography className='status_text'>
                            Priority Name
                            <span className='required_span'>*</span>
                        </Typography>
                        <Controller
                            name="priority_name"
                            // className="mb-16"
                            defaultValue={''}
                            control={control}
                            render={({ field }) => (
                                <>
                                    <TextField
                                        {...field}
                                        variant='outlined'
                                        required
                                        fullWidth
                                        error={!!priorityFormErrors.priority_name}
                                        helperText={priorityFormErrors?.priority_name?.message}
                                        FormHelperTextProps={{
                                            style: { 
                                                margin : 0, 
                                                backgroundColor: '#f4f4f4',
                                                width: '100%',
                                                paddingTop: '2px',
                                                fontSize: '10px'
                                            }
                                        }}
                                    />
                                </>
                            )}
                        />
                    </div>
                    <div>
                        <Typography className='status_text'>
                            Choose Color
                        </Typography>
                        <ColorPicker setColor={setColor} color={color}/>
                    </div> 
                </div>
            </DialogContent>
            <DialogActions className="action_footer_holder">
                <Button onClick={handleOpenCloseAddModalEvent} className="secondary_btn">Cancel</Button>
                <Button onClick={priorityFormSubmit(onSubmit)} className="primary_btn">
                    Save and Select
                </Button>
            </DialogActions>
        </Dialog>
    );


}

export default  AddServicePriorityFromQuickAction;